import axios from 'axios';
import React,{useState,useEffect} from 'react';
import Form from './Form';

function Update(props) {
    const id = props.location.pathname.slice(8);
    const [result,setResult] = useState(() => []);

    useEffect( () => {
        axios.get(`https://art-book-fm.herokuapp.com/app/art/${id}`)
        .then((promise) => setResult(promise.data[0]))
    },[])
    
    const fetchData = (id) => {
        props.history.push(`/art/${id}`)
    }

    return(
            <Form 
                nameComponent="update"
                form = {result.form}
                name = {result.name}
                year = {result.year}
                artist = {result.artist}
                image = {result.image}
                id = {id}
                onClick = {fetchData}
            />
        
    )
}

export default Update;